import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { ICreator } from '@/interfaces';
import routes from '@/lib/routes';

type TDataVariables = Omit<ICreator, 'createdAt' | 'updatedAt' | 'referralCount'>;
type TResponseData = string;

export const useRequestEditCreator = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.referrals, 'edit'],
    mutationFn: ({ _id, ...data }: TDataVariables) =>
      apiClient
        .put<TResponseData>(`${routes.api.referrals}/${_id}`, data)
        .then(handleApiResponse),
    onSuccess: () => invalidate(routes.api.referrals)
  });

  const trigger = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoading: isPending,
    trigger,
    error
  });

};  
